/* eslint-disable @typescript-eslint/no-unused-vars */
// import getVisitorId from "./getVisitorId";
import config from "@Config/index";
import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";
import getCookie from "./getCookie";
import { isApp } from "hooks/useIsApp";
import trackMpGAEvent from "./mpTracker";
import { getPostHogEventContext, posthogEventEmitter } from "@Utils/posthog";
import blacklistGrowthbookFlagsFromGA from "constants/blacklistGrowthbookFlagsFromGA";

const getSectionName = () => {
  let name = "";
  if (window?.location?.search?.includes("gallery=true")) {
    name = "gallery";
  }
  return name;
};

const getWhitelabelPartnerId = () => {
  if (typeof window !== "undefined") {
    const initialState = window?.__INITIAL_STATE__ as any;
    if (initialState?.whitelabelData?.partner_id) {
      return initialState?.whitelabelData?.partner_id;
    }
  }
  return "";
};

const gtagEventEmitter = ({
  action,
  category,
  label = "",
  value = "",
  isWebApp = false,
  ...args
}: any) => {
  const inApp = isApp() || isWebApp;
  const page_url = typeof window !== "undefined" ? window.location.href : "";
  const page_path = typeof window !== "undefined" ? window.location.pathname : "";

  const event_params = {
    event_category: category,
    ...(Boolean(label) && { event_label: label }),
    ...(Boolean(value) && { value }),
    ...(Boolean(getSectionName()) && { section: getSectionName() }),
    ...args,
    ...getPostHogEventContext(),
    ...(!inApp && { new_user_website: true }),
    ...(config.IS_WHITELABEL_APP && {
      is_whitelabel: true,
      whitelabel_partner_id: getWhitelabelPartnerId(),
    }),
    ...(Boolean(isMiniProgramUserAgent()) && { mini_program: true }),
    user_agent: window?.navigator?.userAgent,
    search_sorting_key: getCookie("search_sorting_key"),
    search_page_v2: getCookie("search_page_v2"),
    search_sorting_key_v2: getCookie("search_sorting_key_v2"),
    search_sorting_key_v2_50: getCookie("search_sorting_key_v2_50"),
    overview_gallery: getCookie("overview_gallery"),
    ...(page_url && { page_url, page_path }),
  };

  if (action) {
    posthogEventEmitter({
      action,
      category,
      label,
      value,
      ...event_params,
    });
  }

  if (
    action === "experiment_viewed" &&
    args.experiment_id &&
    blacklistGrowthbookFlagsFromGA.includes(args.experiment_id)
  ) {
    return;
  }

  if (inApp) return; // skipping gtag for app (PostHog captured above)

  if (config.IS_CHINA_APP) return; // skipping gtag for China app — GA is not used

  if (Boolean(isMiniProgramUserAgent()) && action) {
    trackMpGAEvent({
      event_name: action,
      event_params,
      source: "mini_program",
    });
    return; // skipping gtag for mini program
  }
  // @ts-ignore
  if (typeof gtag !== "undefined" && action) {
    // @ts-ignore
    gtag("event", action, event_params);
  }
};

export const gtagDuplicateEventEmitter = (eventObj: any) =>
  setTimeout(() => gtagEventEmitter(eventObj), 10);

export default gtagEventEmitter;
